module.exports = __webpack_public_path__ + "static/img/recommend-list-11.db099b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/main/recommend-list-11.png
// module id = jFat
// module chunks = 1